import {Collapse} from "antd";
import React from "react";
import './style.less'
import i18n from "../../../i18n";

export default function Accordion() {
  const Panel = Collapse.Panel;

  const content = [
    {
      title: i18n.t('landing.qa.items.1.title'),
      text: i18n.t('landing.qa.items.1.text')
    },
    {
      title: i18n.t('landing.qa.items.2.title'),
      text: i18n.t('landing.qa.items.2.text')
    },
    {
      title: i18n.t('landing.qa.items.3.title'),
      text: i18n.t('landing.qa.items.3.text')
    },
    {
      title: i18n.t('landing.qa.items.4.title'),
      text: i18n.t('landing.qa.items.4.text')
    },
    {
      title: i18n.t('landing.qa.items.5.title'),
      text: <span dangerouslySetInnerHTML={{__html:i18n.t('landing.qa.items.5.text')}}/>
    },
    {
      title: i18n.t('landing.qa.items.6.title'),
      text: <span dangerouslySetInnerHTML={{__html:i18n.t('landing.qa.items.6.text')}}/>
    },
  ]

  return (
    <Collapse bordered="false"
              className="qa__items"
              style={{background: "transparent", border: "none"}}
              expandIcon={() => <button className="qa-card__btn">
                <svg width="42" height="44" viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M42 38L21 44L-5.24537e-07 38L-3.8466e-06 3.67176e-06L42 0L42 38Z" fill="#FFDB06"/>
                  <path d="M27 18L21 24L15 18" stroke="#44803F" strokeWidth="2"/>
                </svg>
              </button>}
    >
      {content.map((item, index) =>
        <Panel
          header={
            <div className="qa-card__show">
              <div className="qa-card__title display4 green-text">{item.title}</div>
            </div>
          }
          key={index + 1}
          className="qa-card"
        >
          <div className="qa-card__hidden">
            <div className="text20 medium-weight gray-text">{item.text}</div>
          </div>
        </Panel>
      )}
    </Collapse>
  )
};
